import { useRef } from "react";
import { useStoreState } from "ezStore";
import moment from "moment";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { DatePicker as CCKDatePicker } from "@cofano/cck";
import { HtmlEvent } from "@cofano/cck/Table/Table";
import { DatePickerBaseProps } from "@cofano/cck/DatePicker/DatePickerBase";
import { DateUtils } from "utils/DateUtils";
import useDateSegmentSelect from "components/hooks/useDateSegmentSelect";

const DatePicker = ({
	value,
	placeholderText,
	onChange,
	disablePortal,
	...otherProps
}: Omit<DatePickerBaseProps, "value" | "onChange"> & {
	disablePortal?: boolean;
	value?: number | null;
	onChange: (date: number | null, event: HtmlEvent) => void;
}) => {
	const { user } = useStoreState((store) => store.session);
	const language = DateUtils.getDatePickerLocale(user?.language);

	const inputRef = useRef<HTMLInputElement | null>(null);

	const dateFormat = () => {
		if (otherProps.showTimeSelectOnly) {
			return DateUtils.getTimeFormat();
		} else if (otherProps.showTimeSelect || otherProps.showTimeInput) {
			return DateUtils.getDateTimeFormat(language);
		} else {
			return DateUtils.getDateFormat(language);
		}
	};

	const currentFormat = dateFormat();

	const { selectSegmentAtCursor } = useDateSegmentSelect(
		inputRef,
		currentFormat,
		Boolean(value),
	);

	return (
		<CCKDatePicker
			{...otherProps}
			inputRef={inputRef}
			onInputClick={selectSegmentAtCursor}
			value={value ? moment(value).toDate() : undefined}
			onChange={(date, event) =>
				onChange(date ? moment(date).unix() * 1000 : null, event)
			}
			portalId={!disablePortal ? "date-picker-container" : ""}
			popperPlacement={"bottom-start"}
			placeholderText={placeholderText || currentFormat}
			showWeekNumbers
			fixedHeight
		/>
	);
};

export default DatePicker;
